import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { I18NextService } from 'angular-i18next';
import { TaskState } from '../../enums/task-state.enum';

@Component({
    selector: 'status-filter-drop-down',
    templateUrl: './status-filter-drop-down.component.html',
    styleUrls: ['./status-filter-drop-down.component.scss'],
})
export class StatusFilterDropDown {
    @Input() selectedStatus: TaskState[] = [];
    @Output() statusChange = new EventEmitter<TaskState[]>();

    openedFlyout = false;

    @Input() rightAlignment: boolean = false;

    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    @Input() statusOptions = [
        { label: 'Open', value: TaskState.OPEN },
        { label: 'In Progress', value: TaskState.IN_PROGRESS },
        { label: 'In Review', value: TaskState.IN_REVIEW },
        { label: 'Completed', value: TaskState.DONE },
    ];
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedStatus.length > 0;

    constructor(private readonly localizedTexts: I18NextService) {
        this.statusOptions[0].label = this.localizedTexts.t('aumico_pm_tasks_status_open') as string;
        this.statusOptions[1].label = this.localizedTexts.t('aumico_pm_tasks_status_in_progress') as string;
        this.statusOptions[2].label = this.localizedTexts.t('aumico_pm_tasks_status_in_review') as string;
        this.statusOptions[3].label = this.localizedTexts.t('aumico_pm_tasks_status_done') as string;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedStatus']) {
            this.isFilterActive = this.selectedStatus.length > 0;
        }
    }

    toggleStatusSelection(value: TaskState): void {
        if (this.singleSelection) {
            this.selectedStatus = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedStatus.includes(value);
        this.onStatusSelection(value, !isCurrentlySelected);
    }

    onStatusSelection(value: TaskState, checked: boolean) {
        if (this.singleSelection) {
            this.selectedStatus = [];
            this.selectedStatus.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedStatus.push(value);
        } else {
            this.selectedStatus = this.selectedStatus.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedStatus.length > 0;
        this.closeFlyout();
        this.statusChange.emit(this.selectedStatus);
    }

    clearFilter(): void {
        this.selectedStatus = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.statusChange.emit(this.selectedStatus);
    }
}
